"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "title3ClassNames", {
    enumerable: true,
    get: function() {
        return _useTitle3Stylesstyles.title3ClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Title3"), exports);
const _useTitle3Stylesstyles = require("./useTitle3Styles.styles");
